<div class="tag-connection custom-theme-modal modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered" role="document">
<div class="modal-content ">
  <div class="modal-header d-block py-3 border-color">
    <div class="row">
      <div class="col-6 pr-0 d-flex align-items-center">
        <h6 class="heading-4">
          <span class="cursor-pointer" (click)="backToPrevious()">
            <img class="pb-1" src="assets/themes/icons/grey-arrow.svg" alt="back">
          </span>
          <span class="color-grey-700">
            {{mls.languageText.create_post_community.key6}}
          </span>
        </h6>
      </div>
      <div class="col-6 text-right">
        <button type="button"  [ngClass]="showColor ? 'filled' : 'filled-disabled'"  (click)="fileUploadingProcess()" [disabled]="showColor==false"
          class="btn-design filled medium w-25 position-relative h-auto">
           {{mls.languageText.create_post_community.key2}}
        </button>
      </div>
    </div>
  </div>

  <div class="modal-body pt-2 pb-4 create-post-modal-body">

    <ul>
        <li class="w-100" *ngFor="let topic of topicList">
          <label class="list-item radio w-100">
            <input type="radio" name="list-for" [checked]="isSelectedTopic(topic?.code)"  [value]="topic?.code" [name]="'name'" (click)="addTopic($event, topic)"  />
            <span class="paragraph-bold">{{topic?.name}}</span>
          </label>
        </li>

        <div *ngIf="loading_data_in_process==true" class='text-center w-100'>
          <img src="assets/themes/images/img-video-loader.gif" width="40" id="loadmore_post">
        </div>
    </ul>

  </div>

  </div>
  </div>